
import { reactApi, reactElement } from "../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { createObj } from "../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { ofArray, singleton } from "../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { createElement } from "react";
import React from "react";
import { concat, join } from "../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { useTranslation } from "react-i18next";
import { singleton as singleton_1, append, delay, toList } from "../fable_modules/fable-library-js.5.0.0-rc.2/Seq.js";

export const closeIcon = reactElement("svg", createObj(ofArray([["viewBox", (((((0 + " ") + 0) + " ") + 24) + " ") + 24], ["fill", "none"], ["stroke", "currentColor"], ["strokeWidth", 1.8], ["strokeLinecap", "round"], ["aria-hidden", "true"], (() => {
    const elements = singleton(reactElement("path", {
        d: "M18 6L6 18M6 6l12 12",
    }));
    return ["children", reactApi.Children.toArray(Array.from(elements))];
})()])));

export const backIcon = reactElement("svg", createObj(ofArray([["viewBox", (((((0 + " ") + 0) + " ") + 24) + " ") + 24], ["fill", "none"], ["stroke", "currentColor"], ["strokeWidth", 1.8], ["strokeLinecap", "round"], ["strokeLinejoin", "round"], ["aria-hidden", "true"], (() => {
    const elements = singleton(reactElement("path", {
        d: "M19 12H5M12 19l-7-7 7-7",
    }));
    return ["children", reactApi.Children.toArray(Array.from(elements))];
})()])));

export const openPageIcon = reactElement("svg", createObj(ofArray([["viewBox", (((((0 + " ") + 0) + " ") + 24) + " ") + 24], ["fill", "none"], ["stroke", "currentColor"], ["strokeWidth", 1.8], ["strokeLinecap", "round"], ["strokeLinejoin", "round"], ["aria-hidden", "true"], (() => {
    const elements = singleton(reactElement("path", {
        d: "M15 3h6v6M10 14L21 3M21 14v5a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5",
    }));
    return ["children", reactApi.Children.toArray(Array.from(elements))];
})()])));

export const plusIcon = reactElement("svg", createObj(ofArray([["viewBox", (((((0 + " ") + 0) + " ") + 24) + " ") + 24], ["fill", "none"], ["stroke", "currentColor"], ["strokeWidth", 2], ["strokeLinecap", "round"], ["aria-hidden", "true"], (() => {
    const elements = singleton(reactElement("path", {
        d: "M12 5v14M5 12h14",
    }));
    return ["children", reactApi.Children.toArray(Array.from(elements))];
})()])));

export function PanelIconButton(props) {
    let elems_1;
    return reactElement("button", createObj(ofArray([["type", "button"], ["data-test-id", props.TestId], ["title", props.Label], ["aria-label", props.Label], ["className", join(" ", ["h-10", "w-10", "shrink-0", "rounded-lg", "flex", "items-center", "justify-center", "text-black", "hover:bg-background", "cursor-pointer"])], ["onClick", (_arg) => {
        props.OnClick();
    }], (elems_1 = [reactElement("div", {
        className: join(" ", ["h-5", "w-5"]),
        children: reactApi.Children.toArray([props.Icon]),
    })], ["children", reactApi.Children.toArray(Array.from(elems_1))])])));
}

export function PanelHeader(props) {
    let elems_1, elems;
    const patternInput = useTranslation();
    return reactElement("div", createObj(ofArray([["data-test-id", props.TestId], ["className", join(" ", ["h-16", "shrink-0", "border-b-[2px]", "border-border", "flex", "items-center", "justify-between", "gap-2", "pl-4", "pr-2"])], (elems_1 = [props.Title, reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "items-center", "gap-1", "shrink-0"])], (elems = toList(delay(() => append(props.Actions, delay(() => singleton_1(createElement(PanelIconButton, {
        Icon: closeIcon,
        Label: patternInput[0]("activity_bar.close_panel"),
        OnClick: props.OnClose,
        TestId: concat(props.TestId, ..."-close"),
    })))))), ["children", reactApi.Children.toArray(Array.from(elems))])])))], ["children", reactApi.Children.toArray(Array.from(elems_1))])])));
}

export function panelTitle(text) {
    return reactElement("span", {
        className: join(" ", ["font-semibold", "text-base", "truncate"]),
        children: text,
    });
}

